import React, { CSSProperties } from 'react'
import { Container } from './styled'
import i18n from 'live/services/i18n'

interface Props {
    message?: string
    style?: CSSProperties
}

const EmptyMessage: React.FC<Props> = ({ message, style }) => {
    return (
        <Container style={style}>
            <i className="fas fa-empty-set" />
            {message || i18n(`No data`)}
        </Container>
    )
}
export default EmptyMessage
